import { create } from "zustand";

import { PlayerHeight } from "./PlayerHeight.1";

export const usePlayerHeight = create<PlayerHeight>((set) => ({
  playerHeight: 0,
  setPlayerHeight: (h) => set(() => ({ playerHeight: h })),
}));
